import EA from 'helpers/init';
import Macy from 'macy';

export default EA.Methods.blockMasonry = ($this) => {
    let macyInst = null;
    let macyInstantiated = false;
    const breakpoint = $this.getAttribute('data-breakpoint') || false;

    breakPointCheck();

    if(breakpoint) {
        addEventListener('resize', (e) => {
            breakPointCheck();
        });
    }

    function breakPointCheck() {
        if (window.matchMedia(`(max-width: ${breakpoint}px)`).matches) {
            if (macyInstantiated) {
                macyInst.remove();
                macyInstantiated = false;
            }
        }
        else {
            if (!macyInstantiated) {
                macyInst = Macy({
                    container: $this,
                    columns: 3,
                    trueOrder: true,
                    margin: {
                        x: 20,
                        y: 64  
                    },
                    breakAt: {
                        1000: {
                            columns: 2,
                        }
                    }
                });
                macyInstantiated = true;
            }
        }
    }
};
